import usePersistedState from 'src/hooks/globalState/usePersistedState';
import StorageKeys from 'src/lib/storage/storageKeys';
export default function useUserStorage() {
    return usePersistedState(StorageKeys.userDetails);
}
